import {BooleanPicker} from 'views/AppLocals/Exam/ExamContext'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'

export const productVariantFormSchema = {
    active: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1 md:col-span-2', 'col-span-1'],
        children: [
            {
                name: 'active',
                label: 'active',
                component: createControlledFormField({
                    Component: BooleanPicker,
                }),
            },
        ],
    },
    variant_codes: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'sku code',
                name: 'variant_code',
                component: createControlledFormField({
                    placeholder: 'sku code',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'barcode / warehouse link',
                name: 'barcode',
                component: createControlledFormField({
                    placeholder: 'barcode / warehouse link',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'Ref ID',
                name: 'ref_id',
                component: createControlledFormField({
                    placeholder: 'Ref ID',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },
    rate_qtty: {
        inline: true,
        className: 'grid grid-cols-1 lg:grid-cols-4 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'compare price',
                name: 'compare_price',
                component: createControlledFormField({
                    placeholder: 'compare price',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'retail price',
                name: 'price',
                component: createControlledFormField({
                    placeholder: 'retail price',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'weight (g)',
                name: 'weight',
                component: createControlledFormField({
                    placeholder: 'weight (g)',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'initial quantity',
                name: 'quantity',
                component: createControlledFormField({
                    placeholder: 'initial quantity',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'blocked quantity',
                name: 'blocked_quantity',
                component: createControlledFormField({
                    placeholder: 'blocked quantity',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'sold quantity',
                name: 'sold_quantity',
                component: createControlledFormField({
                    placeholder: 'sold quantity',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },
    attribute_1: {
        inline: true,
        className: 'grid grid-cols-1 lg:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'code',
                name: 'attribute1_code',
                component: createControlledFormField({
                    placeholder: 'attribute1 code',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'name',
                name: 'attribute1_name',
                component: createControlledFormField({
                    placeholder: 'attribute1 name',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'value',
                name: 'attribute1_value',
                component: createControlledFormField({
                    placeholder: 'attribute1 value',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },
    attribute_2: {
        inline: true,
        className: 'grid grid-cols-1 lg:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1', 'col-span-1'],
        children: [
            {
                label: 'code',
                name: 'attribute2_code',
                component: createControlledFormField({
                    placeholder: 'attribute1 code',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'name',
                name: 'attribute2_name',
                component: createControlledFormField({
                    placeholder: 'attribute1 name',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
            {
                label: 'value',
                name: 'attribute2_value',
                component: createControlledFormField({
                    placeholder: 'attribute1 value',
                    showCount: true,
                    maxLength: 120,
                    className: 'rounded-md',
                }),
            },
        ],
    },
}
